var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "fill-height" },
    [
      _c("v-container", { staticClass: "mt-0 pt-6", attrs: { fluid: "" } }, [
        _c(
          "div",
          {
            staticClass:
              "grid grid-flow-row grid-cols-3 grid-rows-3 gap-4 bg-black",
          },
          [
            _c("div", { attrs: { id: "video-chat-window" } }),
            _c(
              "v-card",
              {
                staticClass: "d-flex align-center justify-center mb-6",
                attrs: { flat: "", height: "calc(100vh - 194px)", tile: "" },
              },
              [
                _c(
                  "v-card",
                  {
                    staticClass: "pa-2 text-center",
                    attrs: { flat: "", width: "300" },
                  },
                  [
                    _c("div", { staticClass: "text-h5 mb-2" }, [
                      _vm._v("Join a Meeting"),
                    ]),
                    _c("v-text-field", {
                      attrs: {
                        label: "MeetingID",
                        outlined: "",
                        "hide-details": "",
                        filled: "",
                      },
                    }),
                    _c(
                      "v-btn",
                      {
                        staticClass: "mt-2",
                        attrs: { color: "success", width: "100%", large: "" },
                      },
                      [_vm._v("Join")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }